<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader title="Meeting List">
        <el-input prefix-icon="el-icon-search" placeholder="Search" v-model="searchVal" v-debounce="onSearch" clearable
          @clear="onSearch" />
        <!-- <el-button type="primary" icon="el-icon-plus" @click="handleEdit()">
          Create Meeting
        </el-button> -->
      </PageHeader>
    </div>
    <div class="table-wrapper">
      <el-table size="mini" v-loading="tableLoading" element-loading-text="Loading..." :data="tableData"
        @sort-change="onSortChange" ref="SeTable">
        <el-table-column type="expand" width="20px">
          <template slot-scope="{ row }">
            <div class="table-expand-wrapper">
              <el-row type="flex" justify="space-around">
                <el-col :span="5">
                  <p>Id</p>
                  <p>{{ row.MeetingCode }}</p>
                </el-col>
                <el-col :span="5">
                  <p>Question</p>
                  <p>{{ row.QuestionInfo }}</p>
                </el-col>
                <el-col :span="5">
                  <p>Comments</p>
                  <div style="width: 80%; word-break: break-all">
                    {{ row.CommentDetail }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <p>Forward Comments</p>
                  <div class="comment-content" v-html="commentFormatter(row.CommentForward)" />
                </el-col>
              </el-row>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Title" label="Title" sortable="custom" min-width="155" />
        <el-table-column width="160" prop="StatusDesc" label="Status" sortable="custom" />
        <el-table-column prop="MeetingLink" label="Meeting Link" sortable="custom" width="200">
          <template slot-scope="{ row }">
            <template v-if="
              row.MeetingLink === '' ||
              row.MeetingLink === null ||
              row.MeetingLink === 'null'
            ">
              <a :href="`https://mlwechat.lillycare.com.cn/Meetings/Edit/${row.MeetingId}`" target="_blank">
                Meeting Detail
              </a>
            </template>
            <template v-else>
              <a :href="row.MeetingLink" target="_blank">Join Meeting</a>
              <span class="meeting-code">({{ row.MeetingCode }})</span>
              <span class="copy-btn" :data-clipboard-text="row.MeetingLink" @click="copyURLLink">
                <i class="el-icon-document-copy"></i>
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column width="150" prop="StartTime" label="Start Time" sortable="custom"
          :formatter="startDateFormatter" />
        <el-table-column width="150" prop="EndTime" label="End Time" sortable="custom" :formatter="endDateFormatter" />
        <el-table-column prop="Source" width="95" label="Source" sortable="custom" :formatter="sourceValue" />
        <el-table-column label="Operation" width="100" align="center">
          <template slot-scope="{ row }" prop="StatusDesc">
            <OptionMenu icon="iconfont icon-more-menu" iconSize="18">
              <OptionMenuItem icon="el-icon-edit" title="Edit" @click="handleEdit(row)" />
              <OptionMenuItem icon="el-icon-delete" title="Delete" @click="handleDelete(row)" />
              <OptionMenuItem icon="iconfont icon-share" title="Forward" @click="chooseForwardNumber(row)" />
              <!-- <OptionMenuItem icon="el-icon-view" title="Feedback" v-if="isVMSL" @click="handleRate(row)" /> -->
            </OptionMenu>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 25, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" />
      </div>
    </div>
    <EditMeetingDialog :visible.sync="dialogVisible" :data.sync="editRow" @success="onSuccess" />
    <ForwardMeetingDialog :visible.sync="forwardMeetingDialogVisible" :data.sync="editRow" @success="onSuccess" />

    <!-- rate-dialog -->
    <el-dialog title="View Feedback" :visible.sync="showRateDialog" width="75%" append-to-body destroy-on-close
      custom-class="rateDialog">
      <el-table size="mini" v-loading="tableLoadingRate" element-loading-text="Loading..." :data="tableDataRate"
        ref="SeTable">
        <el-table-column prop="SEName" :label="isVMSL ? 'vCE Name' : 'HCP Name'" min-width="50" />
        <el-table-column prop="Professional" label="对医学人员解答您学术问题的专业能力是否满意？" min-width="100">
          <template slot-scope="{ row }">
            {{ row.Professional==null?'':(row.Professional == 1 ? '满意' : '不满意') }}
          </template>
        </el-table-column>
        <el-table-column prop="Information" label="对医学人员为您提供的学术信息、资料是否满意？" min-width="100">
          <template slot-scope="{ row }">
            {{ row.Information==null?'':(row.Information == 1 ? '满意' : '不满意') }}
          </template>
        </el-table-column>
        <el-table-column prop="Timeliness" label="对医学人员回应您学术需求的及时性是否满意？" min-width="100">
          <template slot-scope="{ row }">
            {{ row.Timeliness==null?'':(row.Timeliness == 1 ? '满意' : '不满意') }}
          </template>
        </el-table-column>
        <el-table-column prop="Convenience" label="对系统操作的便利度是否满意？" min-width="100">
          <template slot-scope="{ row }">
            {{ row.Convenience==null?'':(row.Convenience == 1 ? '满意' : '不满意') }}
          </template>
        </el-table-column>
        <el-table-column width="150" prop="Feedbackon" label="评价时间"/>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Clipboard from "clipboard";
import ForwardMeetingDialog from "../commons/forward-dialog";
import EditMeetingDialog from "../commons/edit-meeting-dialog";
import { RoleCode } from '@/utils/role-constant'
export default {
  name: "Online-Meeting",
  components: { EditMeetingDialog, ForwardMeetingDialog },
  data() {
    return {
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      searchVal: "",
      tableLoading: true,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: "CreateDt",
      orderType: "descending",
      qrcodeURL: "",
      dialogVisible: false,
      forwardMeetingDialogVisible: false,
      editRow: null,
      tableLoadingRate: true,
      tableDataRate: [],
      currentPageRate: 1,
      pageSizeRate: 10,
      totalRate: 0,
      showRateDialog: false
    };
  },
  computed: {
    isVMSL() {
      return this.$store.state.role === RoleCode.VMSL
    },
  },
  created() {
    this.getMeetingList();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getMeetingList();
      }
    });
  },
  methods: {
    commentFormatter(value) {
      if (!value) return "";
      let values = value.split("\n");
      values = values.filter((str) => str !== "");
      values = values.map((str) => {
        let strs = str.split(":");
        return `<div class="comment-item"><strong>${strs[0]}:</strong><span>${strs[1]}</span></div>`;
      });
      return values.join("");
    },
    getMeetingList() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
      };

      this.axios
        .get(`/meeting/getList`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data;
            this.total = data.total;
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    onSuccess(type) {
      this.currentPage = type === "new" ? 1 : this.currentPage;
      this.getMeetingList();
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getMeetingList();
    },
    sourceValue(row, column, value) {
      return value === "MedicalEnquiry" ? "RTMS" : "自创建";
    },
    copyURLLink() {
      let clipboard = new Clipboard(".copy-btn");
      clipboard.on("success", () => {
        this.$message.success("Copy meeting link successfully");
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        this.$message.error("Copy meeting link failed");
        clipboard.destroy();
      });
    },
    startDateFormatter(row) {
      return moment(new Date(row.StartTime)).format(this.dateFormat);
    },
    endDateFormatter(row) {
      return moment(new Date(row.EndTime)).format(this.dateFormat);
    },
    chooseForwardNumber(row) {
      if ((row.Status !== 0 && row.Status !== 3) || row.AllowForward == "0") {
        this.$message.info(
          "Only the meeting on Open/Rescheduled status can be forwarded by its owner/supervisor!"
        );
        return;
      }
      if (row.ModifyBy === "TransferData") {
        this.$message(
          "Meeting transferred from old system cannot be forwarded!"
        );
        return;
      }
      this.editRow = row;
      this.forwardMeetingDialogVisible = true;
    },
    genetateQRCode() { },
    handleEdit(row) {
      if (row != null) {
        if (row.Status !== 0 && row.Status !== 3) {
          this.$message(
            "Only the meeting on Open/Rescheduled status can be edited!"
          );
          return;
        }
        if (row.ModifyBy === "TransferData") {
          this.$message(
            "Meeting transferred from old system cannot be edited!"
          );
          return;
        }
      }
      this.editRow = row;
      this.dialogVisible = true;
    },

    handleDelete(row) {
      if (row.Status !== 0 || row.Source != "MeetingDefault") {
        this.$message.info(
          "Only non RTMS meeting on Open status can be deleted!"
        );
        return;
      }
      if (row.ModifyBy === "TransferData") {
        this.$message("Meeting transferred from old system cannot be deleted!");
        return;
      }
      this.$confirm("Once deleted, it cannot be recovered.", "Attention", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then(() => {
        this.axios
          .post("/meeting/delete", {
            meetingId: row.MeetingId,
            ReasonCode: 1,
            ReasonDetail: "",
          })
          .then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "Delete meeting successfully",
              });
              this.getMeetingList();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "info",
              message: "error: " + err,
            });
          });
      });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getMeetingList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getMeetingList();
    },
    onSearch() {
      this.currentPage = 1;
      this.getMeetingList();
    },
    handleRate(row) {
      this.showRateDialog = true;
      this.getRateList(row)
    },
    handleSizeChangeRate(pageSize) {
      this.pageSizeRate = pageSize;
      this.getRateList();
    },
    handleCurrentChangeRate(currentPage) {
      this.currentPageRate = currentPage;
      this.getRateList();
    },
    getRateList(row) {
      this.tableLoadingRate = true;
      // let params = {
      //   pageSize: this.pageSizeRate,
      //   page: this.currentPageRate,
      // };

      this.axios
        .get(`/meeting/getMeetingRate?meetingId=${row.MeetingId}`)
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableDataRate = data;
            // this.totalRate = data.tot?al;
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoadingRate = false;
        })
        .catch(() => {
          this.tableLoadingRate = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-table {
  ::v-deep {
    .meeting-code {
      padding: 0 5px;
    }

    .copy-btn {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 16px;
    }
  }
}

.operations {
  text-align: center;
}

.qrcode-popover {
  margin-right: 10px;
}

.qrcode-btn,
.edit-btn,
.delete-btn {
  padding: 5px;
}

.fromMeeting {
  width: 100%;
}

.el-icon-document-copy {
  color: #008dc3;
}

.copy-btn.disabled {
  .el-icon-document-copy {
    color: #c0c4cc;
  }
}

.meeting-link.disabled,
.copy-btn.disabled {
  color: #c0c4cc !important;
  pointer-events: none;
  cursor: not-allowed;
}

.comment-content {
  width: 120%;
  overflow: hidden;
  white-space: normal;
  word-break: break-word;

  ::v-deep .comment-item {
    line-height: 18px;
    display: flex;

    strong {
      white-space: nowrap;
      margin-right: 2px;
    }
  }
}
</style>